import { useMutation } from '@apollo/client';
import { Select as AntdSelect, Button, Form, Input, Space } from 'antd';
import React from 'react';
import {
  MAX_LENGTHS,
  MODULES,
  PAGE_TYPES,
  ROUTES,
  WORKSPACE_ROLE_LEVEL,
  WORKSPACE_ROLE_PERMISSION
} from '../../common/constants';
import { formValidatorRules } from '../../common/utils';
import PageHeader from '../../components/PageHeader';
import history from '../../historyData';
import useCheckPermission from '../../hooks/useCheckPermission';
import { Permissions } from '../pages/component/pageModules/moduleForms/FormInputs';
import { CREATE_PAGE_TEMPLATE } from './graphql/Mutations';

const PAGE_TEMPLATE_TYPE_OPTIONS = [
  { label: 'Video', value: PAGE_TYPES.VIDEO }
  // commented for future use
  // { label: 'Podcast', value: PAGE_TYPES.PODCAST }
];

const initialValues = {
  title: '*',
  type: PAGE_TYPES.VIDEO,
  templateName: '',
  description: '',
  permissions: [],
  metaHeader: '',
  metaFooter: '',
  metaImage: ''
};

const AddPageTemplate = () => {
  const [form] = Form.useForm();

  const isAddEditAllowed = useCheckPermission([
    {
      moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
      allowedPermissions: [
        WORKSPACE_ROLE_LEVEL.EDIT,
        WORKSPACE_ROLE_LEVEL.DELETE
      ]
    }
  ]);

  const [createTemplate, { loading }] = useMutation(CREATE_PAGE_TEMPLATE, {
    onCompleted: () => history.replace(ROUTES.PAGE_TEMPLATES),
    onError: () => {}
  });

  const handleSubmit = ({ permissions, type, ...values }) => {
    createTemplate({
      variables: {
        data: {
          ...values,
          type,
          permissions: permissions?.map(({ value }) => value) ?? []
        }
      }
    });
  };

  const handleCancel = () => {
    history.replace(ROUTES.PAGE_TEMPLATES);
  };

  return (
    <>
      <PageHeader menu={MODULES?.UI_CONFIGURATION} />
      <div className="page-wrapper">
        <div className="page-wrapper-body">
          <Form
            form={form}
            name="page-template-form"
            layout="vertical"
            className="add-edit-form"
            onFinish={handleSubmit}
            initialValues={initialValues}
          >
            <Form.Item
              name="title"
              label="Title"
              required
              rules={[
                formValidatorRules?.required('Please enter title!'),
                formValidatorRules?.maxLength(MAX_LENGTHS.TITLE)
              ]}
            >
              <Input placeholder="Enter title" disabled readOnly />
            </Form.Item>

            <Form.Item name="type" label="Type" required>
              <AntdSelect options={PAGE_TEMPLATE_TYPE_OPTIONS} />
            </Form.Item>

            <Form.Item
              name="templateName"
              label="Template Name"
              required
              rules={[
                formValidatorRules?.required('Please enter template name!'),
                formValidatorRules?.maxLength(MAX_LENGTHS.TITLE)
              ]}
            >
              <Input placeholder="Enter template name" />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
            >
              <Input placeholder="Enter description" />
            </Form.Item>

            <Form.Item name="metaImage" label="Meta Image">
              <Input placeholder="Enter image URL" />
            </Form.Item>

            <Form.Item
              name="metaHeader"
              label="Meta Header"
              rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
            >
              <Input.TextArea rows={5} placeholder="Enter meta header" />
            </Form.Item>

            <Form.Item
              name="metaFooter"
              label="Meta Footer"
              rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
            >
              <Input.TextArea rows={5} placeholder="Enter meta footer" />
            </Form.Item>

            <Permissions />

            <div className="d-flex button-section">
              <Space>
                {isAddEditAllowed && (
                  <Form.Item>
                    <Button
                      loading={loading}
                      type="text"
                      htmlType="submit"
                      className="text-btn mr-8"
                      size="middle"
                    >
                      Save
                    </Button>
                  </Form.Item>
                )}
                <Form.Item>
                  <Button
                    type="text"
                    className="text-btn2"
                    disabled={loading}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Space>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AddPageTemplate;
